import Color from 'color'

export function colorWithOpacity(color: string, opacity: number): string {
    return Color(color).alpha(opacity).string()
}